export default __webpack_public_path__ + "static/Plan-and-Build-2ef68e13963f4cf47f5244755b0bec20.webp";